type AudioType = "christmas" | "one" | "random";

const audioFiles: {[key: number | string]: string} = {
  1: "/audio/pig1.mp3",
  2: "/audio/pig2.mp3",
  3: "/audio/pig3.mp3",
  4: "/audio/pig4.mp3",
  christmas: "/audio/vanoce-prasata.mp3",
};

export const playPigSound = (type: AudioType) => {
  let audio = null;

  if (type === "christmas") {
    audio = new Audio(audioFiles.christmas);
  } else if (type === "one") {
    audio = new Audio(audioFiles[1]);
    // random sound by default
  } else {
    const random = Math.floor(Math.random() * 4 + 1);
    audio = new Audio(audioFiles[random]);
  }

  audio.play();

  return audio;
};
